module.exports = __webpack_public_path__ + "static/media/twitter.b8fe13ca.svg";